/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Person',dictionary:{"de":{"references":{"organization":"Organisation"},"general":{"title":"Titel","role":"Funktion","firstname":"Vorname","lastname":"Nachname","gender":"Anrede","birthday":"Geburtsdatum"},"__getters":{"localAddress":"Adresse","internationalAddress":"Adresse","titleName":"Name","lastFirstTitleName":"Name","lastFirstName":"Name","birthdayCalenderWeek":"Geburtsdatum"},"address":{"street":"Straße und Nummer","zipCode":"PLZ","city":"Ort","country":"Land","__getters":{"localAddress":"Adresse","interationalAddress":"Adresse"}},"communication":{"phone":"Telefon","mobile":"Mobil","email":"Email"}},"en":{"references":{"organization":"Organization"},"general":{"title":"Title","role":"Role","firstname":"Firstname","lastname":"Lastname","gender":"Salutation","birthday":"Birthday"},"__getters":{"localAddress":"Address","internationalAddress":"Address","titleName":"Name","lastFirstTitleName":"Name","lastFirstName":"Name","birthdayCalenderWeek":"Birthday"},"address":{"street":"Street and Number","zipCode":"Zip-Code","city":"City","country":"Country","__getters":{"localAddress":"Address","interationalAddress":"Address"}},"communication":{"phone":"Phone","mobile":"Mobile","email":"Email"}}}})
import { Login } from './Login';
import { Organization } from './Organization';
import _ from 'lodash';

export class Person extends _BaseModel {
	
	static toString() {
		return 'Person'
	}
	
	get __getters() {
		const self = this;
		return {
			get localAddress() {
        return (self.address.street ? self.address.street + ', ' : '') + (self.address.zipCode ? self.address.zipCode + '-' : '') + self.address.city;
    },
			get internationalAddress() {
        return (
            (self.address.street ? self.address.street + ', ' : '') +
            (self.address.zipCode ? self.address.zipCode + '-' : '') +
            (self.address.city ? self.address.city + ', ' : '') +
            self.address.country
        );
    },
			get lastFirstName() {
        const personString = _.get(self.general, 'lastname', '') + ' ' + _.get(self.general, 'firstname', '');
        return personString;
    },
			get titleName() {
        let personString = '';
        const title = _.get(self.general, 'title', '');
        if (title) personString += title + ' ';
        personString += _.get(self.general, 'firstname', '') + ' ' + _.get(self.general, 'lastname', '');
        return personString;
    },
			get lastFirstTitleName() {
        let personString = '';
        const title = _.get(self.general, 'title', '');
        personString += _.get(self.general, 'lastname', '') + ' ' + _.get(self.general, 'firstname', '');
        if (title) personString += ', ' + title;
        return personString;
    },
			get titleNameShortName() {
        let personString = '';
        const title = _.get(self.general, 'title', '');
        personString += _.get(self.general, 'lastname', '') + ' ' + _.get(self.general, 'firstname', '');
        if (title) personString += ', ' + title;

        if (_.get(self.references, 'organization') && _.get(self.references, 'organization')) {
            personString += ' | ' + _.get(self.references, 'organization.general.shortName', '');
        }
        if (_.get(self.references, 'organization') && !_.get(self.references, 'organization')) {
            personString += ' | ' + _.get(self.references, 'organization.general.shortName', '');
        }

        return personString;
    },
			get birthdayCalenderWeek() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.dateCalendarWeek(self.general.birthday);
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Person.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Person', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Person.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Person', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Person.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Person', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Person', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Person', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Person.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Person', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Person'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Person) || _BaseModel.t('rules.reference', {modelName:'Person', path:'meta.currentDocument'}) ],
				model: Person,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Person', path:'meta.revisions'}) ],
				model: Person,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	organization:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Organization'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Organization) || _BaseModel.t('rules.reference', {modelName:'Person', path:'references.organization'}) ],
				model: Organization,
				returnObject: true,
},
    
	},
	
},
			general: 				{
					
	title:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.general.title'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'general.title'}) ],
},
    
	},
	
					
	role:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.general.role'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'general.role'}) ],
},
    
	},
	
					
	firstname:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.general.firstname'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'general.firstname'}) ],
},
    
	},
	
					
	lastname:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.general.lastname'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Person', path:'general.lastname'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Person', path:'general.lastname'}) ],
},
    
	},
	
					
	gender:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.general.gender'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'general.gender'}) ],
},
    
	},
	
					
	birthday:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Person.general.birthday'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Person', path:'general.birthday'}) ],
},
    __isDate: true,
	},
	
},
			address: 				{
					
	street:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.address.street'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'address.street'}) ],
},
    
	},
	
					
	zipCode:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.address.zipCode'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'address.zipCode'}) ],
},
    
	},
	
					
	city:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.address.city'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'address.city'}) ],
},
    
	},
	
					
	country:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.address.country'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'address.country'}) ],
},
    
	},
	
},
			communication: 				{
					
	phone:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.communication.phone'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'communication.phone'}) ],
},
    
	},
	
					
	fax:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.communication.fax'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'communication.fax'}) ],
},
    
	},
	
					
	mobile:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.communication.mobile'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'communication.mobile'}) ],
},
    
	},
	
					
	email:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.communication.email'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'communication.email'}) ],
},
    
	},
	
					
	website:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person.communication.website'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Person', path:'communication.website'}) ],
},
    
	},
	
},
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Person._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, general={}, address={}, communication={}, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.general=GeneralClass.create(general);
		this.address=AddressClass.create(address);
		this.communication=CommunicationClass.create(communication);
		this._id=_id;
	}

	static create(data) {
		return new Person(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Person || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Person.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Person ? item : Person.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({organization=undefined, }={}){
		this.organization= (organization instanceof Organization || typeof organization === 'string' || !organization) ? organization : Organization.create(organization);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class GeneralClass {
	constructor({title='', role='', firstname='', lastname='', gender='', birthday=undefined, }={}){
		this.title=title;
		this.role=role;
		this.firstname=firstname;
		this.lastname=lastname;
		this.gender=gender;
		this.birthday=birthday;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}

class AddressClass {
	constructor({street='', zipCode='', city='', country='', }={}){
		this.street=street;
		this.zipCode=zipCode;
		this.city=city;
		this.country=country;
	}

	static create(data) {
		return new AddressClass(data);
	}
}

class CommunicationClass {
	constructor({phone='', fax='', mobile='', email='', website='', }={}){
		this.phone=phone;
		this.fax=fax;
		this.mobile=mobile;
		this.email=email;
		this.website=website;
	}

	static create(data) {
		return new CommunicationClass(data);
	}
}
